import Immutable from 'immutable';
import { AppState, AppStateActionParams } from 'records/AppState';
import { BreadcrumbItem } from 'records/BreadcrumbItem';
import { Breadcrumbs, RawBreadcrumbs } from 'records/Breadcrumbs';

export interface BreadcrumbActions {
  setBreadcrumbs: (
    actionParams: AppStateActionParams,
    breadcrumb: BreadcrumbItem
  ) => Promise<AppState>;
  resetBreadcrumbs: (actionParams: AppStateActionParams) => Promise<AppState>;
}

const breadcrumbActions = {
  setBreadcrumbs: async (
    { state }: AppStateActionParams,
    breadcrumb: BreadcrumbItem
  ): Promise<AppState> => {
    const currentBreadcrumbs = state().get('breadcrumbsItems');
    const folderList = currentBreadcrumbs.folders.toIndexedSeq();
    const hasBreadcrumb = folderList.indexOf(breadcrumb) !== -1;
    let updatedBreadcrumbs;

    if (hasBreadcrumb) {
      const currentBreadcrumbIndex = folderList.indexOf(breadcrumb);
      const truncatedFolders = folderList.slice(0, currentBreadcrumbIndex + 1);

      const updatedBreadcrumbPath: RawBreadcrumbs = {
        key: currentBreadcrumbs.key,
        folders: Immutable.OrderedSet(truncatedFolders),
      };
      updatedBreadcrumbs = new Breadcrumbs(updatedBreadcrumbPath);
    } else {
      const withAddedBreadcrumb = currentBreadcrumbs.folders.add(breadcrumb);
      const updatedBreadcrumbPath: RawBreadcrumbs = {
        key: currentBreadcrumbs.key,
        folders: withAddedBreadcrumb,
      };
      updatedBreadcrumbs = new Breadcrumbs(updatedBreadcrumbPath);
    }

    return state().set('breadcrumbsItems', updatedBreadcrumbs);
  },
  resetBreadcrumbs: async ({
    state,
  }: AppStateActionParams): Promise<AppState> => {
    const emptyBreadcrumbs = new Breadcrumbs();
    return state().set('breadcrumbsItems', emptyBreadcrumbs);
  },
};

export default breadcrumbActions;
